import moment from 'moment'
import * as _ from 'lodash';

export class DeliveryDateCalculator {
  constructor(order) {
    this.order = order;
    this.nextCutoffDate = moment(this.order.next_cutoff);
    this.firstValidDeliveryDate = this.nextCutoffDate.clone().add('1', 'day').startOf('day');
    this.deliveryDateMode = _.get(order.distributor_account_config, 'delivery_date_mode');
    this.usesIntegratedDeliveryDates = this.order.distributor.uses_integrated_delivery_dates;

    this.mondayDeliveryEnabled = function(date) {
      let distributorMondayDelvieryEnabled = this.order.distributor.monday_delivery_on_weekend_orders;
      let firstValidDateIsMonday = this.firstValidDeliveryDate.day() === 2
      if(distributorMondayDelvieryEnabled && firstValidDateIsMonday) {
        return date.isSameOrAfter(this.nextCutoffDate.startOf('date'))
      }

      return false;
    }

    this.validIntegratedDate = function(date) {
      date = moment(date)
      return (
        (date.isSameOrAfter(this.firstValidDeliveryDate) || this.mondayDeliveryEnabled(date)) &&
        this.availableDaysOfTheWeek().includes(String(date.day()))
      );
    };

    this.availableDaysOfTheWeek = function() {
      if (!this.usesIntegratedDeliveryDates) { return [0, 1, 2, 3, 4, 5, 6].map(String) }

      switch(this.deliveryDateMode) {
        case 'lakeshore':
        case 'multiple':
          return _.get(this.order.distributor_account_config,'delivery_days_of_week')
        default:
          let d = _.get(this.order.distributor_account_config,'delivery_day_of_week')
          if (d) { d = String(d) }
          return [d]
      };
    };

    this.integratedDeliveryDates = function() {
      let now = moment();

      const dates = _.get(order.distributor_account_config, "delivery_dates", []);
      
      dates.map(item => {
        return {
          date: moment(item.date, "YYYY-MM-DD"),
          cutoff: moment(item.cutoff),
          integrated: true
        }
      }).filter(item => !item.cutoff || (item.cutoff && item.cutoff.isAfter(now)));

      return dates
    }

    this.firstIntegratedDeliveryDate = function() {
      if (this.usesIntegratedDeliveryDates) {
        let dates = this.integratedDeliveryDates();

        if (dates.length > 0) {
          return dates[0]
        }
      }

      this.dates =
        this.order.delivery_dates.map(date => {
          date.date = moment(date.date);

          if (this.validIntegratedDate(date.date)) { date.integrated = true }
          return date;
        }).filter(date => {
          return this.mondayDeliveryEnabled(date.date) || date.date.isAfter(this.nextCutoffDate)
        })

      return this.dates.find(date => date.integrated);
    }
  };
}
